import { ovl } from "../../../../_ovlclient/src"
import { LanguageSet } from "../../../../_ovlclient/src/global/globalapi"
import {
  _SetFeatureInfo,
  hasOSReducedMotion,
} from "../../../../_ovlclient/src/global/globals"

import { HookSYSLoginSuccess, HookSYSLoginSuccess_Type } from "./hooks"

export const InitStateFromLogin = async (res: any) => {
  let state = ovl.getState()
  //<trick> to quickly fadeOut dialog after login success
  //we cannot close the dialog here because it awaits a promise which would be resolved then to early
  let el = document.getElementById("ovldialog_SYSLogin_SYSLogin")
  if (el) {
    if (hasOSReducedMotion()) {
      el.classList.add("ovl-hide")
    } else {
      el.classList.add("fadeOutScreen")
    }
  }
  //</trick>

  state.ovl.user.role = res.data.user.role
  state.ovl.user.permissions = res.data.user.permissions
  state.ovl.user.userCode = res.data.user.userCode
  if (state.ovl.users === undefined) {
    state.ovl.users = {}
  }
  state.ovl.users[state.ovl.user.userCode] = {
    features: res.data.user.features,
  }

  let isRelogin = !!state.ovl.app.clientId
  state.ovl.app.clientId = res.data.user.clientId

  if (res.data.allUsersRoles) {
    res.data.allUsersRoles.forEach((ur) => {
      _SetFeatureInfo(
        ur.CntctCode,
        ur.Code,
        ur.Text1,
        ur.Text2,
        ur.Text3,
        ur.Json1,
        ur.Val1,
        ur.Val2
      )
    })
  }
  state.ovl.user.userId = res.data.user.userId
  state.ovl.user.email = res.data.user.userEmail
  state.ovl.user.cardCode = res.data.user.cardCode
  state.ovl.user.cardName = res.data.user.cardName
  state.ovl.user.firstName = res.data.user.firstName
  state.ovl.user.lastName = res.data.user.lastName
  state.ovl.user.isActor = res.data.user.isActor

  // this will load the remaining translations if not already loaded
  if (!state.ovl.language.translationComplete) {
    let lang = res.data.user.language
    if (!lang) {
      lang = state.ovl.session?.Language
    }
    await LanguageSet(lang)
  }

  // call HookSYSLoginSuccess
  //@ts-ignore (we need this ignore for login less apps (otto rohr))
  let fn = ovl.getActions().app.features.SYSLogin.hooks[HookSYSLoginSuccess]
  await fn(<HookSYSLoginSuccess_Type>{ isRelogin })
}
